import type { Table } from "@tanstack/react-table";
import type { PropsWithChildren } from "react";

import {
  ActionBar,
  RowsSelected,
} from "@/components/shared/tables/ActionBar";
import { Button, type ButtonProps } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

const TableActionBarRoot = ({
  children,
  className,
}: PropsWithChildren<{
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}>) => {
  return (
    <ActionBar className={cn("absolute", className)}>{children}</ActionBar>
  );
};

const TableActionBarRowsSelected = ({
  table,
}: {
  table: Table<any>;
}) => {
  return (
    <RowsSelected
      totalRowsLength={table?.getRowCount()}
      selectedRowsLength={table?.getSelectedRowModel()?.flatRows?.length}
      onDeselectAll={() => table.resetRowSelection(true)}
    />
  );
};

const TableActionBarButton = ({
  children,
  onClick,
  className,
  tooltip,
  ...rest
}: PropsWithChildren<ButtonProps & { tooltip?: string }>) => {
  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              {...rest}
              onClick={onClick}
              className={cn("gap-1 disabled:pointer-events-auto", className)}
            >
              {children}
            </Button>
          </TooltipTrigger>
          <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Button {...rest} onClick={onClick} className={cn("gap-1", className)}>
      {children}
    </Button>
  );
};

export { TableActionBarRoot, TableActionBarButton, TableActionBarRowsSelected };
